import {IdentityDocumentType} from '@sollapay/enums';
import {useTranslation} from 'react-i18next';

import {PartyTypeToggle} from '@/components/roster';

import type {ButtonGroupItemDef} from '@sollapay/ui/components';
import type {FC} from 'react';

export interface IdentityTypeToggleProps {
  value: IdentityDocumentType;
  onChange: (value: IdentityDocumentType) => void;
}

export const IdentityTypeToggle: FC<IdentityTypeToggleProps> = ({value, onChange}) => {
  const {t} = useTranslation('common');

  const items: ButtonGroupItemDef[] = [
    {value: IdentityDocumentType.NATIONAL_ID, label: t('identity.typeNationalId'), icon: 'shield'},
    {value: IdentityDocumentType.PASSPORT, label: t('identity.typePassport'), icon: 'passport'}
  ];

  return (
    <PartyTypeToggle
      label={t('identity.type')}
      required
      value={value}
      onChange={val => onChange(val as IdentityDocumentType)}
      items={items}
    />
  );
};
